export function Spinner({ size = 28, tone = 'dark' }: { size?: number; tone?: 'dark' | 'light' }) {
  return (
    <span
      role="status"
      aria-label="טוען"
      className={[
        'inline-block animate-spin rounded-full border-[2.5px]',
        tone === 'light' ? 'border-white/40 border-t-white' : 'border-line-strong border-t-brand',
      ].join(' ')}
      style={{ width: size, height: size }}
    />
  );
}
